import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-bold text-ink">
            {t('common.pageNotFound')}
          </h2>
          <p className="mt-2 text-center text-sm text-ink-muted">
            {t('common.pageNotFoundMessage')}
          </p>
        </div>
        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-primary-foreground bg-primary hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring"
          >
            {t('common.goBackHome')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 